import React from "react";
import styled from "styled-components";
import "./Loader.css";

const Container = styled.div``;

const Loader = () => {
	return (
		<Container>
			<div className="lds-ellipsis">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</Container>
	);
};

export default Loader;
